export interface INavigationRoute {
  name: string
  displayName: string
  description?: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'Inicio',
  },
  routes: [
    {
      name: 'inicio',
      displayName: 'Inicio',
      description: 'Resumen operativo y tareas pendientes',
      meta: {
        icon: 'home',
      },
    },
    {
      name: 'alumnos',
      displayName: 'Alumnos',
      description: 'Ficha, expedientes y vista del portal',
      meta: {
        icon: 'school',
      },
    },
    {
      name: 'matriculas',
      displayName: 'Matrículas',
      description: 'Borradores, solicitudes y estados',
      meta: {
        icon: 'assignment',
      },
    },
    {
      name: 'portal-tramites',
      displayName: 'Portal de trámites',
      description: 'Trámites académicos y administrativos',
      meta: {
        icon: 'description',
      },
    },
    {
      name: 'incidencias-atc',
      displayName: 'Incidencias / ATC',
      description: 'Seguimiento global por alumno y trámite',
      meta: {
        icon: 'support_agent',
      },
    },
    {
      name: 'gestion-notificaciones',
      displayName: 'Gestión de notificaciones',
      description: 'Plantillas, envíos, grupos e histórico',
      meta: {
        icon: 'notifications',
      },
    },
    {
      name: 'administracion',
      displayName: 'Administración',
      description: 'Configuración funcional y técnica',
      meta: {
        icon: 'settings',
      },
    },
  ] as INavigationRoute[],
}
